import { Select } from "melco-ui";
import { useAppDomain } from "../../../hooks/appdomain/useAppDomain";
import { useTranslation } from "react-i18next";

export type PressureFootSelectProps = {

    value?: string[];
    onchange: (e: string[]) => void
}
type presserFootOptions = {
    label: string;
    value: string;
}
export const PressureFootSelect: React.FC<PressureFootSelectProps> = ({ value, onchange }) => {

    let options: presserFootOptions[] = []
    const { pressureFootOptions } = useAppDomain();
    const { t } = useTranslation();
    options = pressureFootOptions && pressureFootOptions !== ""
        ? pressureFootOptions.split(",").map((pfo) => ({
            label: pfo,
            value: pfo
        }))
        : [];


    return <>
        <Select
            //name="presser_foot"
            allowClear
            mode="multiple"
            value={value}
            onChange={onchange}
            options={options}
            placeholder={t('managehoops.tabs.basic.presser_foot')}
            style={{ width: "100%", minWidth: "150px" }}

        />
    </>
}